<template>
    <LinkHover
        :type="'router-link'"
        :to="$trl({
            name: layout.category === 'project' ? 'Project' : 'Article',
            params: {
                slug: layout.customslug || layout.slug,
                locale: $route.params.locale
            }
        })"
        :classNames="{
            default: 'link-default',
            hover: 'link-hover',
            hoverMask: 'link-hover-mask',
        }"
        :image="layout.image ? layout.image.url : null"
        :class="[
            'link',
            'story',
            {'has-image': layout.image && layout.image.url}
        ]"
    >
        <div class="default">
            <div class="container">
                <div
                    class="tag-container"
                >
                    <span class="tag">{{tag}}</span>
                </div>
                <div
                    class="heading"
                >
                    <h4 v-html="layout.name"/>
                </div>
            </div>
            <div class="footer">
                <span class="date">{{layout.date}}</span>
                <IconLink/>
            </div>
        </div>
        <img
            :src="layout.image.url"
            :alt="layout.image.alt"
            :title="layout.image.title"
            class="seo-image"
        />
        <template v-slot:hover>
            <div
                class="hover"
                :style="style"
            >
                <div class="cover"/>
                <div class="container">
                    <div
                        class="tag-container"
                    >
                        <span class="tag">{{tag}}</span>
                    </div>
                    <div
                        class="heading"
                    >
                        <h4 v-html="layout.name"/>
                    </div>
                </div>
                <div class="footer">
                    <span class="date">{{layout.date}}</span>
                    <IconLink/>
                </div>
            </div>
        </template>
    </LinkHover>
</template>

<script>
import IconLink from '@/components/IconLink'
import LinkHover from '@/components/animation/LinkHover'
export default {
    components: {
        IconLink,
        LinkHover
    },
    props: {
        layout: {
            type: Object,
            default() {}
        },
        taxonomy: {
            type: Array,
            default() {return []}
        }
    },
    computed: {
        style() {
            return this.layout.image ? {
                backgroundImage: `url(${this.layout.image.url})`
            } : {}
        },
        tag() {
            const tag = this.taxonomy.find(_ => _.term_id === this.layout.tag)
            return tag ? tag.name : this.$t('nav.article')
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.board
.container
    flex: 1
.heading
    flex: 0.5648148148
    h4
        display: -webkit-box
        -webkit-line-clamp: 4
        -webkit-box-orient: vertical
        overflow: hidden
        height: 1.4285714286 * 4em
        @media print
            height: auto
.tag-container
    flex: 0.3

.container
    .tag
        color: #ff2b2a
a
    text-decoration: none
.footer
    .date
        .pictured &
                color: #ffffff
svg
    width: 15px
    height: 15px
    transform: rotate(45deg)
    /deep/ path
        fill: #777b84

.link
    // padding-top: 178px
    // padding-right: 75px
    // padding-bottom: 85px
    // padding-left: 85px
    // @include media-breakpoint-down($sm)
    //     padding-top: 145px
    //     padding-right: 51px
    //     padding-bottom: 69px
    //     padding-left: 69px
    /deep/ .link-default
        display: flex
        flex: 1
        .default
            display: flex
            flex-direction: column
            flex: 1
    /deep/ .link-hover
        background: #ff2b2a
    &.has-image
        /deep/ .link-hover-mask
            .cover
                background-color: rgba(0,0,0,.4)
    /deep/ .link-hover-mask
        .cover
            background-image: url('./../../../assets/cross-fade.svg')
            background-size: 45px 45px
            background-position: 50% 50%
            position: absolute
            left: 0
            top: 0
            right: 0
            bottom: 0

        .hover
            color: #FFFFFF
            display: flex
            flex-direction: column
            // padding-top: 178px
            // padding-right: 75px
            // padding-bottom: 85px
            // padding-left: 85px
            background-size: cover
            background-position: 50% 50%
            flex: 1
        .container
            z-index: 1
            .tag
                color: #FFFFFF
        .date
            color: #FFFFFF
        svg
            path
                fill: #FFFFFF
</style>
